/*
 * ISAIA - custom-variant-fallback.js
 * Gestione prodotti multi colore (colore come opzione variante) sul tema Broadcast.
 *
 * 1) PDP: se la combinazione di opzioni scelta non esiste (es. taglia 38 + Grey),
 *    salta alla prima variante che ha il valore appena scelto, preferendo quelle disponibili.
 *    Le combinazioni che esistono ma sono esaurite NON vengono toccate (resta il Notify Me).
 * 2) PDP: le taglie che non esistono per il colore selezionato vengono nascoste dalla griglia
 *    e ricompaiono cambiando colore. Quelle che esistono ma sono esaurite restano barrate (Notify Me).
 * 3) PLP: gli swatch colore puntano alla prima variante disponibile di quel colore
 *    e i colori completamente esauriti vengono barrati.
 * 4) PDP: le taglie vengono riordinate (numeri crescenti, poi XS..4XL, poi UNI) perché Shopify
 *    le tiene nell'ordine di creazione delle varianti.
 *
 * File separato dal bundle Broadcast: sopravvive agli aggiornamenti del tema.
 */
(function () {
  'use strict';

  var OPTION_WRAPPER = '[data-option-position]';
  var OPTION_RADIO = 'input[name^="options"][type="radio"]';
  var OPTION_ANY = 'input[name^="options"], select[name^="options"]';
  var HIDDEN_CLASS = 'variant-option--hidden';

  /* ---------- utilità ---------- */

  function getScope(el) {
    return el.closest('[data-section-type="product"]') ||
      el.closest('[data-quick-view-modal]') ||
      el.closest('[data-product]') ||
      document;
  }

  function getProduct(scope) {
    var el = scope.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function readSelections(scope) {
    var vals = [];
    scope.querySelectorAll(OPTION_WRAPPER).forEach(function (w) {
      var pos = parseInt(w.getAttribute('data-option-position'), 10) - 1;
      var checked = w.querySelector('input[name^="options"]:checked, input[name^="options"][type="hidden"]');
      var select = w.querySelector('select[name^="options"]');
      vals[pos] = checked ? checked.value : (select ? select.value : null);
    });
    return vals;
  }

  function findVariant(product, vals) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === vals[i]; });
    });
  }

  function pickFallback(product, position, value) {
    var cands = product.variants.filter(function (v) { return v.options[position] === value; });
    if (!cands.length) return null;
    return cands.find(function (v) { return v.available; }) || cands[0];
  }

  function colorOptionIndex(product) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (idx === -1 && /colou?r|colore/i.test(name || '')) idx = i;
    });
    return idx;
  }

  /* ---------- PDP: fallback su combinazione inesistente ---------- */

  var applying = false;

  function onOptionChange(e) {
    var input = e.target;
    if (!input.matches || !input.matches(OPTION_ANY)) return;
    if (applying) return;

    var wrapper = input.closest(OPTION_WRAPPER);
    if (!wrapper) return;
    var scope = getScope(input);
    var product = getProduct(scope);
    if (!product || !product.variants) return;

    var changedPos = parseInt(wrapper.getAttribute('data-option-position'), 10) - 1;
    var vals = readSelections(scope);
    vals[changedPos] = input.value;

    if (findVariant(product, vals)) return; // la combinazione esiste: nessun intervento

    var fallback = pickFallback(product, changedPos, input.value);
    if (!fallback) return;

    applySelection(scope, fallback, changedPos);
  }

  /* Porta i selettori sui valori della variante indicata (saltando l'opzione skipPos, già impostata). */
  function applySelection(scope, variant, skipPos) {
    applying = true;
    try {
      scope.querySelectorAll(OPTION_WRAPPER).forEach(function (w) {
        var pos = parseInt(w.getAttribute('data-option-position'), 10) - 1;
        if (pos === skipPos) return;
        var want = variant.options[pos];
        var radios = w.querySelectorAll(OPTION_RADIO);
        if (radios.length) {
          radios.forEach(function (r) {
            if (r.value === want && !r.checked) {
              r.checked = true;
              r.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        } else {
          var select = w.querySelector('select[name^="options"]');
          if (select && select.value !== want) {
            select.value = want;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    } finally {
      applying = false;
    }
  }

  /* ---------- PDP: atterraggio su variante esaurita (link esterni, wishlist, ricerca) ---------- */

  /* Come il comportamento nativo senza ?variant: si parte dalla prima variante acquistabile,
     preferendo lo stesso colore di quella richiesta. Se nulla è acquistabile non si tocca nulla. */
  function fixLanding(scope) {
    var product = getProduct(scope);
    if (!product || !product.variants) return;
    var vals = readSelections(scope);
    var current = findVariant(product, vals);
    if (!current || current.available) return;
    var available = product.variants.filter(function (v) { return v.available; });
    if (!available.length) return;

    var colorIdx = colorOptionIndex(product);
    var best = null;
    if (colorIdx > -1) {
      best = available.find(function (v) { return v.options[colorIdx] === current.options[colorIdx]; });
    }
    best = best || available[0];
    applySelection(scope, best, -1);
  }

  /* ---------- PDP: nascondi le taglie inesistenti per il colore selezionato ---------- */

  function syncOptionVisibility(scope) {
    var product = getProduct(scope);
    if (!product || !product.variants) return;
    var colorIdx = colorOptionIndex(product);
    if (colorIdx < 0) return; // prodotto a un solo colore: nulla da nascondere
    var vals = readSelections(scope);
    var color = vals[colorIdx];
    if (!color) return;

    scope.querySelectorAll(OPTION_WRAPPER).forEach(function (w) {
      var pos = parseInt(w.getAttribute('data-option-position'), 10) - 1;
      if (pos === colorIdx) return; // i colori restano tutti visibili: il fallback li rende cliccabili
      var exists = function (value) {
        return product.variants.some(function (v) { return v.options[pos] === value && v.options[colorIdx] === color; });
      };
      w.querySelectorAll(OPTION_RADIO).forEach(function (r) {
        var box = r.closest('.radio__button') || r.parentElement;
        box.classList.toggle(HIDDEN_CLASS, !exists(r.value));
      });
      w.querySelectorAll('select[name^="options"] option').forEach(function (o) {
        o.hidden = !exists(o.value);
      });
      w.querySelectorAll('[data-popout-option]').forEach(function (o) {
        var value = o.getAttribute('data-value');
        var box = o.closest('li') || o;
        box.classList.toggle(HIDDEN_CLASS, !exists(value));
      });
    });
  }

  function onVariantChange(e) {
    var scope = getScope(e.target);
    syncOptionVisibility(scope);
  }

  /* ---------- PDP: ordinamento taglie ---------- */

  /* Shopify tiene i valori dell'opzione Size nell'ordine di prima comparsa delle varianti,
     quindi 38, 44, le mezze taglie o XS/3XL finiscono in coda. Qui si riordinano i bottoni:
     numeri crescenti (anche con virgola), poi scala lettere 3XS..XS, S, M, L, XL, XXL/2XL, 3XL, 4XL...,
     poi UNI e il resto in coda. */
  var ALPHA_RANK = { 'XXXS': -3, 'XXS': -2, 'XS': -1, 'S': 0, 'M': 1, 'L': 2, 'XL': 3, 'XXL': 4, 'XXXL': 5 };

  function sizeRank(raw) {
    var s = String(raw || '').trim().toUpperCase().replace(/\s+/g, '');
    var m = s.match(/^(\d+)(?:[.,](\d+))?$/);
    if (m) return [0, parseFloat(m[1] + '.' + (m[2] || '0')), ''];
    if (ALPHA_RANK.hasOwnProperty(s)) return [1, ALPHA_RANK[s], ''];
    m = s.match(/^(\d+)X(S|L)$/);            // 2XS, 3XL, 4XL, 5XL...
    if (m) return [1, m[2] === 'L' ? 2 + parseInt(m[1], 10) : -parseInt(m[1], 10), ''];
    return [2, 0, s];                         // UNI e valori non riconosciuti, in coda, ordine alfabetico
  }

  function compareSizes(a, b) {
    var ra = sizeRank(a), rb = sizeRank(b);
    if (ra[0] !== rb[0]) return ra[0] - rb[0];
    if (ra[1] !== rb[1]) return ra[1] - rb[1];
    return ra[2] < rb[2] ? -1 : ra[2] > rb[2] ? 1 : 0;
  }

  function reorderChildren(container, items, getValue) {
    if (items.length < 2) return;
    var sorted = items.slice().sort(function (a, b) { return compareSizes(getValue(a), getValue(b)); });
    var changed = sorted.some(function (el, i) { return el !== items[i]; });
    if (!changed) return;
    sorted.forEach(function (el) { container.appendChild(el); });
  }

  function sortSizeOptions(scope) {
    var product = getProduct(scope);
    if (!product || !product.options) return;
    var sizeIdx = -1;
    product.options.forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (sizeIdx === -1 && /size|taglia/i.test(name || '')) sizeIdx = i;
    });
    if (sizeIdx < 0) return;
    var wrapper = scope.querySelector('[data-option-position="' + (sizeIdx + 1) + '"]');
    if (!wrapper) return;

    // bottoni radio
    wrapper.querySelectorAll('[data-variant-buttons]').forEach(function (group) {
      var boxes = [].filter.call(group.children, function (el) { return el.querySelector(OPTION_RADIO); });
      reorderChildren(group, boxes, function (el) { return el.querySelector(OPTION_RADIO).value; });
    });
    // tendina custom (mobile)
    wrapper.querySelectorAll('[data-popout-list]').forEach(function (list) {
      var items = [].filter.call(list.children, function (el) { return el.querySelector('[data-value]'); });
      reorderChildren(list, items, function (el) { return el.querySelector('[data-value]').getAttribute('data-value'); });
    });
    // select nativo, se presente
    wrapper.querySelectorAll('select[name^="options"]').forEach(function (select) {
      var opts = [].slice.call(select.options);
      reorderChildren(select, opts, function (o) { return o.value; });
    });
  }

  function initScope(scope) {
    if (scope.__variantFallbackInit) return;
    scope.__variantFallbackInit = true;
    try { sortSizeOptions(scope); } catch (e) { /* mai bloccare il form */ }
    fixLanding(scope);
    syncOptionVisibility(scope);
  }

  function initSections() {
    document.querySelectorAll('[data-product-json]').forEach(function (json) {
      initScope(getScope(json));
    });
  }

  /* Form prodotto inseriti dopo il caricamento (quick view, popup look, upsell): stesso trattamento. */
  function observeInjectedForms() {
    if (!window.MutationObserver) return;
    var pending = null;
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches('[data-product-json]') || n.querySelector('[data-product-json]')) found = true;
        });
      });
      if (!found) return;
      clearTimeout(pending);
      pending = setTimeout(initSections, 150); // lascia inizializzare il form al tema
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- PLP: swatch verso la prima variante disponibile ---------- */

  function fixSwatchLinks(el) {
    var product = el.product;
    var colorOption = el.colorOption;
    if (!product || !colorOption) return;
    var pos = (colorOption.position || 1) - 1;
    el.querySelectorAll('[data-swatch-link]').forEach(function (link) {
      var value = link.dataset.swatch;
      if (!value) return;
      var cands = product.variants.filter(function (v) { return v.options[pos] === value; });
      if (!cands.length) return;
      var best = cands.find(function (v) { return v.available; });
      var target = best || cands[0];
      link.href = product.url + '?variant=' + target.id;
      var button = link.closest('[data-swatch-button]');
      if (!best) {
        link.classList.add('sibling__link--sold-out');
        if (button) button.classList.add('swatch__button--sold-out');
        link.title = value + ' - Sold out';
      } else {
        link.classList.remove('sibling__link--sold-out');
        if (button) button.classList.remove('swatch__button--sold-out');
      }
    });
  }

  function patchGridSwatch() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('grid-swatch').then(function () {
      var Cls = customElements.get('grid-swatch');
      if (!Cls || !Cls.prototype.init || Cls.prototype.init.__isaiaPatched) return;
      var origInit = Cls.prototype.init;
      var patched = function () {
        var r = origInit.apply(this, arguments);
        try { fixSwatchLinks(this); } catch (e) { /* mai rompere la PLP */ }
        return r;
      };
      patched.__isaiaPatched = true;
      Cls.prototype.init = patched;
      document.querySelectorAll('grid-swatch').forEach(function (el) {
        if (el.product) { try { fixSwatchLinks(el); } catch (e) {} }
      });
    });
  }

  /* ---------- stili ---------- */

  function injectStyles() {
    if (document.getElementById('variant-fallback-styles')) return;
    var css = '' +
      /* con il fallback attivo le combinazioni inesistenti sono cliccabili: niente barratura */
      '.radio__fieldset .radio__button input.unavailable+label{background-color:transparent;color:inherit;}' +
      '.swatch__button input.unavailable~label:before{display:none;}' +
      /* taglie inesistenti per il colore selezionato */
      '.' + HIDDEN_CLASS + '{display:none !important;}' +
      /* PLP: swatch di colore esaurito */
      '.swatch__button .sibling__link--sold-out{position:relative;display:block;}' +
      '.swatch__button--sold-out{opacity:.55;}';
    var style = document.createElement('style');
    style.id = 'variant-fallback-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- bootstrap ---------- */

  injectStyles();
  document.addEventListener('change', onOptionChange, true);
  document.addEventListener('theme:variant:change', onVariantChange);
  document.addEventListener('shopify:section:load', initSections);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }
  observeInjectedForms();
  patchGridSwatch();
})();
